<h1 class="page-title text-start">{{ 'contact_us.terms.title' | translate }}</h1>

<section class="bg-[#F6F6F6] w-full max-w-[1440px] min-h-screen px-4 pt-6 pb-6 rounded-[16px] mx-auto">

    <section class="bg-white rounded-[16px] shadow-md min-h-screen max-w-[1408px] mx-auto px-4 py-4 space-y-6">


        <section class="relative w-full">
            <img src="/image/terms-and-conditions-header.png" [alt]="'contact_us.terms.header_alt' | translate"
                class="w-full rounded-[16px] object-cover" />
            <div
                class="absolute -bottom-8 end-4 w-[60px] h-[60px] rounded-full bg-white shadow flex items-center justify-center">
                <i class="bi bi-file-earmark-text text-gray-600 text-[25px]"></i>
            </div>
        </section>


        <section class="font-semibold text-start text-[#4B4B4B] mt-12 ms-5 text-[16px]">{{ 'contact_us.terms.main_title' | translate }}</section>


        <div class="ms-5 flex items-center justify-start text-[#4B4B4B] text-[16px] gap-2">
            <i class="bi bi-pin-angle-fill text-[#858585]"></i>
            <span class="font-semibold">{{ 'contact_us.terms.intro_heading' | translate }}</span>
        </div>

        <p class="text-start text-[#121217] text-[12px] mx-auto px-2">
            {{ 'contact_us.terms.intro_body' | translate }}
        </p>

        <ol
            class="list-decimal list-inside text-start sm:text-[15px] md:text-[16px] leading-relaxed space-y-4 text-[#4B4B4B]">

            <li *ngFor="let key of sectionKeys">
                <span class="font-semibold text-[#4B4B4B] text-[16px]">{{ 'contact_us.terms.sections.' + key + '.title' | translate }}</span><br>
                <span class="text-[#121217] text-[12px] whitespace-pre-line">{{ 'contact_us.terms.sections.' + key + '.body' | translate }}</span>
            </li>

        </ol>

    </section>
</section>
